/* eslint-disable jsx-a11y/label-has-associated-control,react/no-unused-prop-types */
import { useFormContext } from 'react-hook-form';

import { Popover } from '@components/organisms/Popover';

import { translate } from '@utils/translations';

import { useMediaQuery } from '@hooks/useMediaQuery';
import { smallScreen } from '@styles/constants';

import { IAttributeFieldProps } from './types';
import * as S from './styles';

export const AttributeFieldDropdown: React.FC<IAttributeFieldProps> = ({
  attribute,
}) => {
  const { register } = useFormContext();
  const [isSmallScreen] = useMediaQuery(`(max-width: ${smallScreen}px)`);

  return (
    <S.Dropdown>
      {attribute.values.map((value) => (
        // eslint-disable-next-line jsx-a11y/label-has-associated-control
        <label key={value.id}>
          <input
            type="radio"
            name={attribute.attribute.slug}
            value={value.slug}
            {...register(attribute.attribute.slug)}
          />
          {isSmallScreen ? (
            <div>
              {value.image && (
                <img src={value.image.url} alt={translate(value, 'name')} />
              )}
            </div>
          ) : (
            <Popover
              triggers={['hint']}
              placement="top"
              overlay={translate(value, 'name')}
            >
              <div>
                {value.image && (
                  <img src={value.image.url} alt={translate(value, 'name')} />
                )}
              </div>
            </Popover>
          )}
        </label>
      ))}
    </S.Dropdown>
  );
};
